import { formatNumber } from "@/utils";

const MetricValue = ({ value }: { value?: number | null }) => (
  <span className="tabular-nums text-foreground">{formatNumber(value ?? 0)}</span>
);

export { MetricValue };
